import {
  DateFieldProps,
  DynamicField,
  DynamicForm,
  FieldVariant,
  SelectFieldProps,
  SelectOption,
} from '@/components/form-builder/form-builder.types';
import { ContractingAuthorityRepository } from '@/store/contracting-authority-state/contracting-authority-state.repository';
import { BehaviorSubject } from 'rxjs';

interface IGetAcHistoryFiltersFormObjectProps {
  store: ContractingAuthorityRepository;
  acOptions: SelectOption[];
  selectedDate: BehaviorSubject<Date | null>;
}

export const getAcHistoryFiltersFormObject = ({ acOptions, store, selectedDate }: IGetAcHistoryFiltersFormObjectProps): DynamicForm => {
  const selectAcField: DynamicField<SelectFieldProps> = {
    label: 'settings.contractingAuthority.history.filters.ac.label',
    variant: FieldVariant.SELECT,
    isRequired: true,
    props: {
      placeholder: 'settings.contractingAuthority.history.filters.ac.placeholder',
      value: store.getNestedObservable<SelectOption>('acSelected'),
      options: acOptions,
      filterEnabled: true,
      onSelectChange(event: SelectOption) {
        store.set('acSelected', event);
      },
    },
  };

  const dateField: DynamicField<DateFieldProps> = {
    label: 'settings.contractingAuthority.history.filters.date',
    variant: FieldVariant.DATE,
    props: {
      value: selectedDate,
      view: 'date',
      onChange: (date: Date) => {
        selectedDate.next(date);
      },
    },
  };

  return {
    title: '',
    grids: [
      {
        title: '',
        isHeaderHidden: true,
        gridItems: [
          {
            fields: [selectAcField, dateField],
          },
        ],
      },
    ],
  };
};
